import { useQuery } from '@based/sdk/react'
import { PageLayout } from '@app/pages/layout/PageLayout'
import { RegionalPageLayout } from '@app/pages/layout/RegionalPageLayout'
import { PageSeo } from '@app/components/core/seo/PageSeo'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { getEntityPageStatus } from '@app/util/getEntityPageStatus'
import { NotFoundPage } from '@app/pages/error/NotFoundPage'
import { MunicipalityViewModel } from 'functions/app/geography/view/municipality'
import { municipalityTabs } from '@app/pages/discover/regions/constants'
import { KnowledgeHubModuleView } from '@app/pages/knowledge-hub/KnowledgeHubModule'

export type MunicipalityKnowledgeHubModulePageProps = {
  municipalitySlug: string
  itemId: string
}

export const MunicipalityKnowledgeHubModulePage = ({
  municipalitySlug,
  itemId,
}: MunicipalityKnowledgeHubModulePageProps) => {
  const t = useTranslations().app.knowledgeHubPage
  const municipalityQuery = useQuery('view-municipality', {
    slug: municipalitySlug,
  })
  const municipality: MunicipalityViewModel | undefined =
    municipalityQuery.data
  const municipalityPageStatus = getEntityPageStatus(
    municipalityQuery.loading,
    municipality,
  )

  if (municipalityPageStatus === 'not-found') {
    return <NotFoundPage />
  }

  if (municipalityPageStatus === 'loading' || !municipality) {
    return (
      <PageLayout gap="2rem">
        <PageSeo />
        {t.loading}
      </PageLayout>
    )
  }

  return (
    <KnowledgeHubModuleView
      itemId={itemId}
      backPath={pages.municipalityPageNew(
        municipalitySlug,
        municipalityTabs.knowledgeHub,
      )}
      renderReady={(body) => (
        <RegionalPageLayout
          municipality={municipality}
          tab={municipalityTabs.knowledgeHub}
          gap="0rem"
        >
          <PageSeo />
          {body}
        </RegionalPageLayout>
      )}
    />
  )
}
